import { supabase } from '../supabaseClient';
import { getAnonId } from './anonId';

const VALID_SOURCE_TYPES = new Set(['crew_invite', 'jury_summon', 'share_link']);

export async function trackReferralAttribution({
  inviterUserId,
  sourceType,
  sourceId = null,
  invitedUserId = null,
}) {
  const normalizedInviterUserId = String(inviterUserId || '').trim();
  const normalizedSourceType = String(sourceType || '').trim();
  const normalizedSourceId = sourceId == null ? null : String(sourceId).trim();
  let normalizedInvitedUserId = invitedUserId == null ? null : String(invitedUserId).trim();

  if (!normalizedInviterUserId || !VALID_SOURCE_TYPES.has(normalizedSourceType)) {
    return { ok: false, skipped: true, reason: 'invalid_referral_payload' };
  }

  if (!normalizedInvitedUserId) {
    try {
      const { data: sessionData } = await supabase.auth.getSession();
      const authUserId = sessionData?.session?.user?.id || null;
      if (authUserId) {
        const { data: userRow } = await supabase
          .from('users')
          .select('id')
          .eq('auth_user_id', authUserId)
          .maybeSingle();
        normalizedInvitedUserId = userRow?.id ? String(userRow.id) : null;
      }
    } catch {}
  }

  if (normalizedInvitedUserId && normalizedInvitedUserId === normalizedInviterUserId) {
    return { ok: true, skipped: true, reason: 'self_referral_blocked' };
  }

  const invitedAnonId = getAnonId();
  const { data, error } = await supabase.functions.invoke('track-referral-attribution', {
    body: {
      inviter_user_id: normalizedInviterUserId,
      invited_user_id: normalizedInvitedUserId || null,
      invited_anon_id: invitedAnonId,
      source_type: normalizedSourceType,
      source_id: normalizedSourceId || null,
    },
  });

  if (error) throw error;
  return data || { ok: true };
}

export async function recordReferralMilestone(milestone) {
  const normalizedMilestone = String(milestone || '').trim();
  if (!normalizedMilestone) return { ok: false, skipped: true, reason: 'missing_milestone' };

  const { data, error } = await supabase.functions.invoke('record-referral-milestone', {
    body: { milestone: normalizedMilestone },
  });

  if (error) throw error;
  return data || { ok: true };
}
